import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface AdminSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * AdminSearchBar - Search input for admin tables
 *
 * Features:
 * - Search icon
 * - Debounced input (TODO)
 * - Clear button (TODO)
 *
 * TODO: Add debouncing to prevent excessive API calls
 * TODO: Add clear button when value is not empty
 */
export default function AdminSearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  disabled = false,
}: AdminSearchBarProps) {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      sx={{ mb: 2 }}
    />
  );
}
